export default class InitBeforeAjax {
    static customInitBeforeAjaxFunctions = [];

    static defaultInitBeforeAjax() {

    }

    static addInitBeforeAjaxFunction(callback) {
        this.customInitBeforeAjaxFunctions.push(callback);
    }
}
